import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

export const Barcode = ({ value, height = 40, width = 1.4, fontSize = 11, displayValue = true }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !value) return;
    try {
      JsBarcode(ref.current, value, { format: "CODE128", height, width, fontSize, margin: 0, displayValue });
    } catch {
      ref.current.innerHTML = "";
    }
  }, [value, height, width, fontSize, displayValue]);
  return value ? <svg ref={ref} data-testid="barcode-svg" /> : null;
};
